import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import site_404 from '@/components/404'
import home from '@/components/home'
import aktualnosci from '@/components/aktualnosci'
import spuscizna_jana_gozdawy from '@/components/aktualnosci/spuscizna_jana_gozdawy'
import relacja_z_obchodow from '@/components/aktualnosci/relacja_z_obchodow'
import urocz_w_wilnie from '@/components/aktualnosci/urocz_w_wilnie'
import odzn_gen_krzyzanowski from '@/components/aktualnosci/odzn_gen_krzyzanowski'
import zawiesz_posw_votum from '@/components/aktualnosci/zawiesz_posw_votum'

import o_autorze from '@/components/o_autorze'
import kolekcja from '@/components/kolekcja'

import historia from '@/components/historia'
import okres_39_41 from '@/components/historia/okres_39_41'
import okres_41_44 from '@/components/historia/okres_41_44'
import dzialalnosc_bojowa from '@/components/historia/dzialalnosc_bojowa'
import powolanie_zgrupowan from '@/components/historia/powolanie_zgrupowan'
import rozbrojenie_aresztowanie_epilog_dokumenty from '@/components/historia/rozbrojenie_aresztowanie_epilog_dokumenty'
import tablice_epitafijne from '@/components/historia/tablice_epitafijne'
import bibliografia from '@/components/historia/bibliografia'

import srodowiska from '@/components/srodowiska'
import okreg_wilenski from '@/components/srodowiska/okreg_wilenski'
import srod_gdansk from '@/components/srodowiska/srod_gdansk'
import srod_warszawa from '@/components/srodowiska/srod_warszawa'

import sponsorzy from '@/components/sponsorzy'
import kontakt from '@/components/kontakt'
Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'site_404',
      component: site_404,
      meta:{
        title: 'AK Wilno - 404'
      }
    },
    {
      path: '/',
      name: 'home',
      component: home,
      meta:{
        title: 'AK Wilno - Strona Główna'
      }
    },
    {
      path: '/index.html',
      name: 'home',
      component: home,
      meta:{
        title: 'AK Wilno - Strona Główna'
      }
    },
    {
      path: '/o_autorze',
      name: 'o_autorze',
      component: o_autorze,
      meta:{
        title: 'AK Wilno - O Autorze'
      }
    },
    {
      path: '/aktualnosci',
      name: 'aktualnosci',
      component: aktualnosci,
      meta:{
        title: 'AK Wilno - Aktualności'
      }
    },
    {
      path: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego',
      name: 'spuscizna_jana_gozdawy',
      component: spuscizna_jana_gozdawy,
      meta:{
        title: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA'
      }
    },
    {
      path: '/aktualnosci/relacja_z_obchodow',
      name: 'relacja_z_obchodow',
      component: relacja_z_obchodow,
      meta:{
        title: 'AK Wilno - Aktualności - Obchody 70. rocznicy operacji „Ostra Brama”'
      }
    },
    {
      path: '/aktualnosci/urocz_w_wilnie',
      name: 'urocz_w_wilnie',
      component: urocz_w_wilnie,
      meta:{
        title: 'AK Wilno - Aktualności - Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK'
      }
    },
    {
      path: '/aktualnosci/odzn_gen_krzyzanowski',
      name: 'odzn_gen_krzyzanowski',
      component: odzn_gen_krzyzanowski,
      meta:{
        title: 'AK Wilno - Aktualności - Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"'
      }
    },
    {
      path: '/aktualnosci/zawiesz_posw_votum',
      name: 'zawiesz_posw_votum',
      component: zawiesz_posw_votum,
      meta:{
        title: 'AK Wilno - Aktualności - Zawieszenie i poświęcenie votum ryngrafów AK'
      }
    },
    {
      path: '/historia',
      name: 'historia',
      component: historia,
      meta:{
        title: 'AK Wilno - Historia AK na Wileńszczyźnie'
      }
    },
    {
      path: '/historia/okres_39_41',
      name: 'okres_39_41',
      component: okres_39_41,
      meta:{
        title: 'AK Wilno - Okres Wrzesień 39\' - Czerwiec 41\''
      }
    },
    {
      path: '/historia/okres_41_44',
      name: 'okres_41_44',
      component: okres_41_44,
      meta:{
        title: 'AK Wilno - Okres Czerwiec 41\' - Lipiec 44\''
      }
    },
    {
      path: '/historia/dzialalnosc_bojowa',
      name: 'dzialalnosc_bojowa',
      component: dzialalnosc_bojowa,
      meta:{
        title: 'AK Wilno - Działalność bojowa Oddziałów i Brygad'
      }
    },
    {
      path: '/historia/powolanie_zgrupowan',
      name: 'powolanie_zgrupowan',
      component: powolanie_zgrupowan,
      meta:{
        title: 'AK Wilno - Powołanie Zgrupowań - Operacja "Ostra Brama" i walki pod Krawczunami'
      }
    },
    {
      path: '/historia/rozbrojenie_aresztowanie_epilog_dokumenty',
      name: 'rozbrojenie_aresztowanie_epilog_dokumenty',
      component: rozbrojenie_aresztowanie_epilog_dokumenty,
      meta:{
        title: 'AK Wilno - Aresztowania, rozbrojenia i represje sowieckie - EPILOG'
      }
    },
    {
      path: '/historia/tablice_epitafijne',
      name: 'tablice_epitafijne',
      component: tablice_epitafijne,
      meta:{
        title: 'AK Wilno - Tablice Epitafijne Okręgu Wileńskiego'
      }
    },
    {
      path: '/historia/bibliografia',
      name: 'bibliografia',
      component: bibliografia,
      meta:{
        title: 'AK Wilno - Bibliografia'
      }
    },
    {
      path: '/kolekcja',
      name: 'kolekcja',
      component: kolekcja,
      meta:{
        title: 'AK Wilno - Kolekcja osobista śp. Janusza Bohdanowicza'
      }
    },
    {
      path: '/srodowiska',
      name: 'srodowiska',
      component: srodowiska,
      meta:{
        title: 'AK Wilno - Środowiska kombatanckie'
      }
    },
    {
      path: '/srodowiska/okreg_wilenski',
      name: 'okreg_wilenski',
      component: okreg_wilenski,
      meta:{
        title: 'AK Wilno - OKRĘG WILEŃSKI POLSKIEGO PAŃSTWA PODZIEMNEGO'
      }
    },
    {
      path: '/srodowiska/srod_gdansk',
      name: 'srod_gdansk',
      component: srod_gdansk,
      meta:{
        title: 'AK Wilno - Środowisko Wileńskie w Gdańsku'
      }
    },
    {
      path: '/srodowiska/srod_warszawa',
      name: 'srod_warszawa',
      component: srod_warszawa,
      meta:{
        title: 'AK Wilno - Środowisko Wileńskie w Warszawie'
      }
    },
    {
      path: '/sponsorzy',
      name: 'sponsorzy',
      component: sponsorzy,
      meta:{
        title: 'AK Wilno - Sponsorzy'
      }
    },
    {
      path: '/kontakt',
      name: 'kontakt',
      component: kontakt,
      meta:{
        title: 'AK Wilno - Kontakt'
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js